
<button
  type="button"
  class="editor-button"
  :class="{ high: high, active: active }"
  :disabled="disabled"
  v-on="$listeners"
>
  <slot><n-icon :icon="icon" size="s" /></slot>
</button>
